import { array, hash } from '@ember/helper';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import {
  PrismLoadingBar,
  PrismModal,
  PrismTabsContainer,
} from '@mylighthouse/prism-ember';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import GeneralButtonsButtonExport from 'lumen/components/general/buttons/button-export';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import HotelStrategyTabEvolutionGraph from 'lumen/components/hotel/strategy/tab-evolution-graph';
import HotelStrategyTablesTableDetailMealtype from 'lumen/components/hotel/strategy/tables/table-detail-mealtype';
import { DETAIL_VIEW_TABS } from 'lumen/utils/constants/rate-strategy-constants';

<template>
  {{! @glint-nocheck: Need to convert controller to *.ts }}
  {{! template-lint-disable no-duplicate-id }}
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{t "strategy.block_title.mealtypes"}}
    {{didInsert @controller.resetContainerDimensions}}
  >
    <:actions>
      <div class="flex items-center gap-400">
        <GeneralIconWithTooltip
          @color="default-inverse"
          @side="top"
          @tooltipContent={{t "strategy.mealtype.detail_modal.info_text"}}
        />
        <GeneralButtonsButtonExport
          @exportAction={{perform @controller.exportRSTableTask}}
          data-event-id="hotel-rate-strategy-detail-export"
          data-event-value={{@controller.router.currentRoute.localName}}
        />
      </div>
    </:actions>
    <:default>
      <div>
        {{#if (or @controller.isLoading @controller.isChartLoading)}}
          <div class="relative">
            <PrismLoadingBar />
          </div>
        {{/if}}
        <div class="modal--stretched">
          {{#if @controller.canRender}}
            <PrismTabsContainer
              @activeTabId={{@controller.tab}}
              @onSelectTab={{@controller.makeActiveTab}}
              @visibleTabIds={{array
                DETAIL_VIEW_TABS.TABLE
                DETAIL_VIEW_TABS.GRAPH
              }}
              as |TabsContainer|
            >
              <TabsContainer.header as |Header|>
                <Header.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  {{t "general.table"}}
                </Header.tab>
                <Header.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  {{t "general.graph"}}
                </Header.tab>
              </TabsContainer.header>
              <TabsContainer.content as |Content|>
                <Content.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  <HotelStrategyTablesTableDetailMealtype
                    @initialSorts={{@controller.initialSorts}}
                    @mealtypeDataPerHotelInfo={{@controller.mealtypeDataPerHotelInfo}}
                    @onTableSort={{@controller.onTableSort}}
                    @sortFunction={{@controller.sortFunction}}
                    @subtypes={{@controller.subtypes}}
                  />
                </Content.tab>
                <Content.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  <HotelStrategyTabEvolutionGraph
                    @params={{hash
                      chooseEntity=@controller.chooseEntity
                      chooseSubtype=@controller.chooseSubtype
                      entity=@controller.entityToDisplay
                      entityId=@controller.entity
                      formattedDates=@controller.formattedDates
                      formattedHistoricData=@controller.formattedHistoricData
                      height=@controller.height
                      historicData=@controller.historicData
                      isLoading=@controller.isChartLoading
                      offset=@controller.offset
                      subtypeId=@controller.subtypeId
                      subtypes=@controller.subtypes
                      type=@controller.typeId
                      updateOffset=@controller.updateOffset
                      width=@controller.width
                    }}
                  />
                </Content.tab>
              </TabsContainer.content>
            </PrismTabsContainer>
          {{/if}}
        </div>
      </div>
    </:default>
  </PrismModal>
</template>
